import "./css/ceo.css";
import ceo from "./img/ceo/ceo.jpg";
import SubHeader from "../components/subHeader";
import dompurify from "dompurify";
import { useTranslation } from "react-i18next";
import i18next from "../config/lang/i18next";
import React, { useRef, useEffect } from "react";
import Cookies from "universal-cookie";
const cookies = new Cookies();

const Ceo = () => {
  /* css 애니메이션 효과 */
  function reveal() {
    var fades = document.querySelectorAll(".fade-up");

    for (var i = 0; i < fades.length; i++) {
      var windowHeight = window.innerHeight;
      var elementTop = fades[i].getBoundingClientRect().top;
      var elementVisible = 20;
      if (elementTop < windowHeight - elementVisible) {
        fades[i].classList.add("fadeInUp");
      } else {
        fades[i].classList.remove("fadeInUp");
      }
    }
  }
  window.addEventListener("scroll", reveal);

  reveal();
  /* 언어 처리 */
  const { t, i18n } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const language = useRef(null);

  useEffect(() => {
    language.current = sessionStorage.getItem("language");
    if (language === null) {
      language.current = cookies.get("language");
    }
    i18next.changeLanguage(language.current);
  }, []);

  return (
    <div className="wrapper">
    <SubHeader />
    <div className="ceo">
      <div className="section_title">
        <h1 className="headerText" style={{marginBottom:"50px"}}>{i18next.t("ceo.title")}</h1>


        <h3>{i18next.t("ceo.title2")}</h3>


      </div>


      <div className="ceo_message">
        <div className="col1 fadeInUp">
          <img src={ceo} alt="img" />
          <p>대표이사 <b>임명한</b></p>
        </div>
        <div className="col2 message fadeInUp">
          <p>{i18next.t("ceo.content")}</p>
       
        </div>
      </div>
    </div>
  </div>

  );
};

export default Ceo;
